import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import MainLayout from '../../Layouts/MainLayout';
import SectionHeader from '../molecules/SectionHeader';
import WindowHeightComponent from '../../Layouts/WindowHeight';
import AccessControl from '../molecules/AccessControl';
import useAccessCheckLoading from '../../../utils/useAccessCheckLoading';
import AccessDenied from '../atoms/AccessDenied';
import Spinner from '../atoms/Spinner';
const ConfigurationPage: FC = () => {
  const navigate = useNavigate()
  const accessCheckLoading = useAccessCheckLoading()
  return (
    <>
      <MainLayout>

        <div className='Title_card my-3'></div>
        <AccessControl
        requiredPermissions={[
          {
            permission: "configurations",
            types: ["read"],
          },
        ]}
        renderNoAccess={ accessCheckLoading ? <Spinner/> :<AccessDenied />}
      >
        <SectionHeader back ={true} title={"Configurations"}></SectionHeader>

        <WindowHeightComponent className={""}>
          <div className="p-3">
            <div className="All-cards p-0">

              {/* <div className="assigned_tiles_inner activate" onClick={() => navigate('/user-page/configuration')} style={{ cursor: 'pointer' }}>
                <h5 className="">User</h5>
              </div> */}
              <div className='assigned_tiles_inner activate' onClick={() => navigate('/role_details')} style={{ cursor: 'pointer' }}>
                <div>
                  <h5 className="">Roles</h5>
                </div>
              </div>
              <div className="assigned_tiles_inner activate" onClick={() => navigate('/permission')} style={{ cursor: 'pointer' }}>
                <div className="">
                  <h5 className="">Permissions</h5>
                </div>
              </div>

            </div>
          </div>

        </WindowHeightComponent>

</AccessControl>
      </MainLayout>
    </>
  );
};

export default ConfigurationPage;
